/* Place the homepage's existing launchers below its content. */
(() => {
  'use strict';

  const initialize = () => {
    const row = document.querySelector('.mm-home-footer__utilities');
    if (!row || row.dataset.mmUtilitiesReady === 'true') return;
    row.dataset.mmUtilitiesReady = 'true';

    const pending = new Set([
      '.mm-mike-tab',
      '#mm-subscription-floating-tab',
      '#smile-ui-lite-launcher-frame-container',
      'shopify-chat'
    ]);
    let observer;

    const moveLaunchers = () => {
      pending.forEach(selector => {
        const launcher = document.querySelector(selector);
        if (!launcher) return;
        if (launcher.parentNode !== row) row.appendChild(launcher);
        pending.delete(selector);
      });
      if (pending.size === 0 && observer) observer.disconnect();
    };

    moveLaunchers();
    if (pending.size === 0) return;

    observer = new MutationObserver(() => {
      if (!row.isConnected) {
        observer.disconnect();
        return;
      }
      moveLaunchers();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
